var React = require('react');

function IcLogin (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_23836_2572)","key":0},React.createElement("path",{"d":"M11 7L9.6 8.4L12.2 11H2V13H12.2L9.6 15.6L11 17L16 12L11 7ZM20 19H12V21H20C21.1 21 22 20.1 22 19V5C22 3.9 21.1 3 20 3H12V5H20V19Z","fill":"black"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_23836_2572"},React.createElement("rect",{"width":"24","height":"24","fill":"white"})))]);
}

IcLogin.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = IcLogin;

IcLogin.default = IcLogin;
